var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar z-index-max",class:[{ 'iphonex-top': _vm.isIphoneX }, { 'bottom-line': _vm.pageName }],style:(_vm.navBarStyle)},[_c('div',{staticClass:"left"},[_vm._t("nav-left")],2),_c('div',{staticClass:"right"},[_vm._t("nav-right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }